module.exports = "/_next/static/images/advance-apps-6313bfe93c0bd089f4a41d1536a93dcc.svg";